import { useEffect } from 'react';

import { ampli } from '~entities/ampli';
import type { FindPaymentsRequestParams } from '~entities/payment';
import { useGenerateReportMutation } from '~entities/payment';
import { isReportGenerated } from '~entities/payment/lib/is-report-generated';
import {
  useCheckReportStatusQuery,
  useDownloadReportQuery,
} from '~entities/report';

import { LoadingButton } from '@platform-ui/button';

import DownloadIcon from './download-icon.svg?react';

export const PaymentsExport = ({
  params,
  disabled,
}: {
  params: FindPaymentsRequestParams;
  disabled?: boolean;
}) => {
  const generateReportMutation = useGenerateReportMutation();
  const checkStatusQuery = useCheckReportStatusQuery(
    generateReportMutation.data?.reportId
  );
  const downloadQuery = useDownloadReportQuery({
    reportData: checkStatusQuery.data,
    screen: 'payments',
  });

  useEffect(() => {
    if (downloadQuery.isSuccess) {
      generateReportMutation.reset();
    }
  }, [downloadQuery.isSuccess, generateReportMutation]);

  const handleExportClick = () => {
    generateReportMutation.mutate(params);
    ampli.paymentsScreenTapExport();
  };
  const reportGenerationInProgress =
    generateReportMutation.isSuccess &&
    !isReportGenerated(checkStatusQuery.data);
  const downloadInProgress =
    isReportGenerated(checkStatusQuery.data) && downloadQuery.isLoading;

  const showLoader =
    generateReportMutation.isPending ||
    reportGenerationInProgress ||
    downloadInProgress;

  return (
    <div className="min-w-[181px]">
      <LoadingButton
        icon={!showLoader && <DownloadIcon />}
        size="m"
        theme="secondary"
        wide
        loading={showLoader}
        disabled={showLoader || disabled}
        onClick={handleExportClick}
      >
        Export to Excel
      </LoadingButton>
    </div>
  );
};
